'use client'

export { resolveAuthConfig } from '@steelhouse/auth-client-core'
export { useAuth as useAuth2 } from '@steelhouse/auth-client-react'
export { useAuth } from '@steelhouse/auth-next/client'

export { AuthenticationBoundary } from './authentication-boundary.tsx'
export {
  AuthenticationProvider,
  SoftAuthenticationProvider,
} from './authentication-provider.tsx'
export * from './components/index.ts'
export * from './redirect-to-sign-in.ts'
